import { registerApplication, start } from 'single-spa'

const loadRoot = () => import('./index.root.js')

registerApplication('root', loadRoot, () => true, {
  domElementGetter: () => document.getElementById('root'),
})

start()
